import React, { Dispatch, SetStateAction } from 'react';
import { CircularProgress, Link } from '@material-ui/core';
import QrCode from 'qrcode.react';
import { useTypedTranslation } from '@app/hooks';
import { SetUpDeviceManualToken, Verify } from './';
import { ActiveMethodManageMfa } from '@app/models';
import Icon from '@app/components/Icon/index';

interface IProps {
    tokenSecret: string;
    encodedKey: string;
    isUserPushActivated: boolean;
    onClickTrouble: (e: React.MouseEvent) => void;
    setIsNeedExpandToken: Dispatch<SetStateAction<boolean>>;
    isNeedExpandTokenBlock: boolean;
    isNeedExpandToken: boolean;
    activeMethod: ActiveMethodManageMfa;
    setPassCode: Dispatch<string>;
    passCode: string;
    errorMessage: string;
    setErrorMessage: Dispatch<string>;
    getMfaCredentials: () => void;
    isTokenSecretLoading: boolean;
    isTokenSecretError: boolean;
}

const notActiveQr = 'rgba(0,0,0,0.1)';
const activeQr = '#000';

export const SetUpDeviceQrCode: React.SFC<IProps> = ({
    encodedKey,
    tokenSecret,
    isUserPushActivated,
    onClickTrouble,
    setIsNeedExpandToken,
    isNeedExpandTokenBlock,
    isNeedExpandToken,
    activeMethod,
    setPassCode,
    passCode,
    errorMessage,
    setErrorMessage,
    getMfaCredentials,
    isTokenSecretLoading,
    isTokenSecretError
}) => {
    const { translation } = useTypedTranslation();

    return (
        <>
            <div className='manage-mfa-token__part manage-mfa-token__part-2'>
                <span>2. </span>
                <span>
                    {isNeedExpandTokenBlock ? (
                        <>
                            {translation('MOBILE_APP_SCAN_QR_CODE_STEP_2_PART_1')}{' '}
                            {isNeedExpandTokenBlock && (
                                <Link className='manage-mfa-token__link' onClick={onClickTrouble} underline='none'>
                                    {translation('MOBILE_APP_SCAN_QR_CODE_STEP_2_PART_2')}
                                </Link>
                            )}
                        </>
                    ) : (
                        <>
                            {translation('MOBILE_APP_ENTER_QR_CODE_STEP_2_PART_1')}{' '}
                            <Link className='manage-mfa-token__link' onClick={onClickTrouble} underline='none'>
                                {translation('MOBILE_APP_ENTER_QR_CODE_STEP_2_PART_2')}
                            </Link>
                        </>
                    )}
                </span>
            </div>
            {isNeedExpandTokenBlock && tokenSecret ? (
                <div className='manage-mfa-token__qrcode--wrapper'>
                    <QrCode size={114} value={tokenSecret} fgColor={`${isUserPushActivated ? notActiveQr : activeQr}`} />
                    {isUserPushActivated && <CircularProgress size={80} className='manage-mfa-token__loader' />}
                </div>
            ) : isNeedExpandTokenBlock && isTokenSecretError ? (
                <div>
                    <div className='manage-mfa-token__qrcode--wrapper'>
                        <Icon icon='codeGenerateErrorIco' className='manage-mfa-token__qrcode-error-icon' />
                        <div className='manage-mfa-token__qrcode-error'>
                            <span className='manage-mfa-token__qrcode-error-text'>{translation('MOBILE_APP_QR_CODE_GENERATE_ERROR_PART_1')}</span>
                            <Link onClick={getMfaCredentials}>{translation('MOBILE_APP_QR_CODE_GENERATE_ERROR_PART_2')}</Link>
                        </div>
                    </div>
                </div>
            ) : isNeedExpandTokenBlock && isTokenSecretLoading ? (
                <div className='manage-mfa-token__loader-block'>
                    <CircularProgress size={80} className='manage-mfa-token__loader' />
                </div>
            ) : null}

            {!isNeedExpandTokenBlock && <SetUpDeviceManualToken isNeedExpandToken={isNeedExpandToken} encodedKey={encodedKey} />}

            <Verify
                activeMethod={activeMethod}
                setPassCode={setPassCode}
                passCode={passCode}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
            />
        </>
    );
};
